export default "__VITE_ASSET__BBF$vQXg__"